import {
  Anchor,
  Box,
  Button,
  Flex,
  Image,
  Stack,
  TextInput,
} from '@mantine/core'
import ExampleProfile from '@assets/exampleProfile.png'
import { useState } from 'react'

export const LocationHighlightedTags = () => {
  const [tags, setTags] = useState<string[]>([])

  const handleAddMore = () => {
    setTags([...tags, ''])
  }
  return (
    <Flex pb="md" pl="md" pr={0}>
      <Box w={450} mt="md">
        <TextInput
          size="md"
          label="Highlight noteworthy tags"
          description="One line max. Displayed in the order listed below."
          placeholder="Example: Severe Health Condition"
        />
        <Stack mt="sm" gap="sm">
          {tags.map((tag, i) => (
            <TextInput key={`highlighted-tags-${i}`} size="md" />
          ))}
          <Anchor onClick={handleAddMore}>+ Add More</Anchor>
        </Stack>
        <Flex maw={450} mt="lg" justify="flex-end" gap="xs">
          <Button size="md" variant="default">
            Discard Changes
          </Button>
          <Button size="md">Save</Button>
        </Flex>
      </Box>
      <Flex justify="flex-end" style={{ flexGrow: 1 }}>
        <Image src={ExampleProfile} w={300} h={272} />
      </Flex>
    </Flex>
  )
}
